<template>
    <div>

        <div class="vx-row justify-around">
            <div class="vx-col lg:w-1/4 w-1/2">
                <vs-checkbox class="mt-3 mb-6" v-model="showAllOrders" >Pokaži vsa naročila</vs-checkbox>
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
                <p style="float: left">Povprečen čas čakanja</p>
                <br>
                <vx-input-group class="mb-base">
                    <template slot="prepend">
                        <div class="prepend-text btn-addon">
                            <vs-button icon-pack="feather" icon="icon-minus-circle" color="primary" @click="setWaitTime(-5)"></vs-button>
                        </div>
                    </template>

                    <vs-input v-model="averageWaitTime" />

                    <template slot="append">
                        <div class="append-text btn-addon">
                            <vs-button icon-pack="feather" icon="icon-plus-circle" color="success" @click="setWaitTime(5)"></vs-button>
                        </div>
                    </template>
                </vx-input-group>
            </div>

        </div>

        <div class="vx-row mt-6 p-6" v-if="orders">

            <div class="vx-col lg:w-1/4 md:w-1/2 mb-6" v-for="order in orders" :key="order.id">

                <vx-card :title="moment(order.order_time).format('DD/MM/YYYY HH:mm')">

                    <vs-button v-if="order.status === 2" class="mb-3 mr-3" color="success" @click="takeOrder(order.id)">Prevzemi naročilo</vs-button>
                    <vs-button v-if="order.status === 3" class="mb-3 mr-3" color="dark" @click="finishOrder(order.id)">Zaključi naročilo</vs-button>
                    <vs-button v-if="order.status === 2 || order.status === 3" class="mb-3 mr-3" color="danger" @click="openCancelOrderPrompt(order.id)">Zavrni naročilo</vs-button>

                    <p><b>Ime:</b> {{order.name}}</p>
                    <p><b>Telefonska številka:</b> {{order.phone_number}}</p>
                    <p><b>Naslov:</b> {{order.address}}</p>
                    <p><b>Tip plačila:</b> {{order.payment_type}}</p>
                    <p><b>Cena jedi:</b> {{order.food_price.toFixed(2)}} &euro;</p>
                    <p><b>Cena dostave:</b> {{order.shipping_price.toFixed(2)}} &euro;</p>
                    <p class="mb-6"><b>Skupna cena:</b> {{order.total_price.toFixed(2)}} &euro;</p>

                    <p class="mb-6"><b style="float: left" class="mt-1">Stanje naročila:</b>
                        <vs-chip class="ml-3" v-if="order.status === 1" color="#f1c40f">Čakanje na potrditev plačila</vs-chip>
                        <vs-chip class="ml-3" v-if="order.status === 2" color="warning">Čakanje na prevzem</vs-chip>
                        <vs-chip class="ml-3" v-if="order.status === 3" color="#6c5ce7">Naročilo potrjeno</vs-chip>
                        <vs-chip class="ml-3" v-if="order.status === 4" color="success">Naročilo zaključeno</vs-chip>
                        <vs-chip class="ml-3" v-if="order.status === 5" color="danger">Naročilo preklicano</vs-chip>
                    </p>

                    <div style="clear: both" class="mb-6"></div>

                    <h4>Jedi</h4>
                    <div class="ml-3 vx-row">
                        <div v-for="item in order.items" :key="item.id" class="mb-6 vx-col w-full">
                            <h6 class="mt-3">- {{item.food_name}}</h6>
                            <div class="ml-6">
                                <p v-if="item.additional_comment.length > 0"><b>Dodatni opis:</b> {{item.additional_comment}}</p>
                                <p><b>Količina:</b> {{item.quantity}}</p>
                                <p><b>Cena:</b> {{item.price.toFixed(2)}} &euro;</p>
                                <p v-for="(value, key) in item.options" :key="key"><b>{{key}}:</b> {{value}}</p>
                                <p v-if="item.additions.length > 0"><b>Dodatki</b></p>
                                <div class="ml-6" v-if="item.additions.length > 0">
                                    <div class="vx-row" v-for="(addition, index) in item.additions" :key="index">
                                        <div v-if="addition.charAt(0) === '-'">
                                            <feather-icon svgClasses="fill-current text-danger" icon="XIcon" style="float: left" />
                                            <p class="ml-2" style="float: left">{{addition.substring(2, addition.length)}}</p>
                                        </div>
                                        <div v-else>
                                            <feather-icon svgClasses="stroke-current text-success" icon="CheckIcon" style="float: left" />
                                            <p class="ml-2" style="float: left">{{addition}}</p>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </vx-card>

            </div>
        </div>

        <vs-prompt
                @accept="cancelOrder"
                title="Prekliči naročilo"
                :active.sync="activeCancelOrderPrompt">
            Naročilo bo preklicano in v primeru spletnega plačila bo plačilo vrnjeno stranki!
        </vs-prompt>

    </div>
</template>
<script>

    require('howler');

    export default {
        data(){
            return {

                orders: null,

                showAllOrders: false,

                updateOrdersTimer: '',

                activeCancelOrderPrompt: false,
                cancelOrderId: 0,

                averageWaitTime: 0,
                updateTimes: false,
                notificationCounter: 0,
            }
        },
        methods: {
            openCancelOrderPrompt(id){
                this.cancelOrderId = id;
                this.activeCancelOrderPrompt = true;
            },
            cancelOrder(){
                const thisIns = this;
                this.$vs.loading();
                this.$http.put('/api/order_management/v1/' + this.$route.params.token + '/order/' + this.cancelOrderId + "/status/5")
                    .then(function () {
                        thisIns.$vs.loading.close();
                    }).catch(function (error) {
                    thisIns.$vs.loading.close();
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            takeOrder(id){
                const thisIns = this;
                this.$vs.loading();
                this.$http.put('/api/order_management/v1/' + this.$route.params.token + '/order/' + id + "/status/3")
                    .then(function () {
                        thisIns.$vs.loading.close();
                    }).catch(function (error) {
                    thisIns.$vs.loading.close();
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            finishOrder(id){
                const thisIns = this;
                this.$vs.loading();
                this.$http.put('/api/order_management/v1/' + this.$route.params.token + '/order/' + id + "/status/4")
                    .then(function () {
                        thisIns.$vs.loading.close();
                    }).catch(function (error) {
                    thisIns.$vs.loading.close();
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            updateOrders(){

                const thisIns = this;

                let url = '/api/order_management/v1/' + this.$route.params.token + '/open';
                if(this.showAllOrders){
                    url = '/api/order_management/v1/' + this.$route.params.token + '/all';
                }

                this.$http.get(url)
                    .then(function (response) {
                        thisIns.orders = response.data;
                        let orderOpen = false;
                        for(let x = 0; x < thisIns.orders.length; x++){
                            if(thisIns.orders[x].status === 2){
                                orderOpen = true;
                            }
                        }

                        if(orderOpen){
                            if(thisIns.notificationCounter === 0) {
                                var sound = new Howl({
                                    src: "/arpeggio.ogg",
                                    volume: 1,
                                });
                                sound.play();
                            }
                            thisIns.notificationCounter++;
                            thisIns.notificationCounter = thisIns.notificationCounter % 10;
                        }else{
                            thisIns.notificationCounter = 0;
                        }

                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            },
            setWaitTime(change){
                const thisIns = this;
                this.$vs.loading();
                this.$http.put('/api/order_management/v1/' + this.$route.params.token + '/wait_time/' + (Number(this.averageWaitTime) + change))
                    .then(function () {
                        thisIns.$vs.loading.close();
                        thisIns.averageWaitTime = Number(thisIns.averageWaitTime) + change;
                        var sound = new Howl({
                            src: "/coins.ogg",
                            volume: 1,
                        });
                        sound.play();
                    }).catch(function (error) {
                    thisIns.$vs.loading.close();
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        beforeDestroy(){
            clearInterval(this.updateOrdersTimer);
        },
        created() {
            const thisIns = this;
            this.$http.get('/api/listing/v1/wait_time/')
                .then(function (response) {
                    thisIns.averageWaitTime = Number(response.data);
                    thisIns.updateTimes = true;
                }).catch(function (error) {
                thisIns.$vs.notify({
                    title:'Error',
                    text: error,
                    color:'danger',
                    iconPack: 'feather',
                    icon:'icon-alert-circle'})
            });
            this.updateOrders();
            this.updateOrdersTimer = setInterval(()=>{ this.updateOrders() }, 1000);
        },
    }

</script>
